import './styles.scss'

interface CardContentInfosGeneralProps {
  children: React.ReactNode
  isNoticeOfInconsistencies?: boolean
}

function CardContentInfosGeneral({
  children,
  isNoticeOfInconsistencies = false,
}: CardContentInfosGeneralProps) {
  return (
    <div
      className={`container-cardContentInfosGeneral cardAnimated ${
        isNoticeOfInconsistencies ? 'isNoticeOfInconsistencies' : ''
      }`}
    >
      {children}
    </div>
  )
}

export default CardContentInfosGeneral
